import { createTheme } from '@material-ui/core/styles';

//TODO: Include new figma colors inside the theme
//TODO: Replace theme with color palette

const colors = {
  /* LM/Primary / SkyBlue */
  lm_primary_skyblue: '#387FF7',
  /* LM/Primary/SkyBlue Dark */
  lm_primary_skyblue_dark: '#2A5FB9',
  /* LM/Primary/SkyBlue Light */
  lm_primary_skyblue_light: '#E7F2FE',
  /* LM/Primary/DarkBlue */
  lm_primary_darkblue: '#23325B',
  /* LM/Primary/Warning */
  lm_primary_warning: '#FF8A00',
  /* LM/Primary / Error */
  lm_primary_error: '#E20000',
  /* LM/Grayscale / Grey 0 */
  lm_grayscale_grey_0: '#FFFFFF',
  /* LM/Grayscale/Grey 10 */
  lm_grayscale_grey_10: '#FBFBFB',
  /* LM/Grayscale/Grey 20 */
  lm_grayscale_grey_20: '#F4F5F7',
  /* LM/Grayscale/Grey 30 */
  lm_grayscale_grey_30: '#EEEEEE',
  /* LM/Grayscale/Grey 40 */
  lm_grayscale_grey_40: '#DDDDDD',
  /* LM/Grayscale/Grey 50 */
  lm_grayscale_grey_50: '#B0B0B0',
  /* LM/Grayscale/Grey 60 */
  lm_grayscale_grey_60: '#777777',
  /* LM/Grayscale/Grey 70 */
  lm_grayscale_grey_70: '#717280',
  /* LM/Grayscale/Grey 80 */
  lm_grayscale_grey_80: '#303032',
  /* LM/Grayscale/Grey 100 */
  lm_grayscale_grey_100: '#000000',
  /* LM / Secondary / Red 01 */
  lm_secondary_red: '#F74359',
};

export default createTheme({
  palette: {
    primary: {
      main: colors.lm_primary_skyblue,
      dark: colors.lm_primary_skyblue_dark,
      light: colors.lm_primary_skyblue_light,
      active: colors.lm_grayscale_grey_0,
      warning: colors.lm_primary_warning,
      darkBlue: colors.lm_primary_darkblue,
      lightGray: colors.lm_grayscale_grey_80,
      infoAlert: '#014361',
    },
    link: {
      main: '#3482F7',
    },
    secondary: {
      main: '#979FAE',
      dark: '#4D4F5C',
      light: '#777777',
      blue01: '#59A5F2',
    },
    error: {
      main: '#FA5252',
    },
    warning: {
      main: colors.lm_primary_warning,
    },
    info: {
      main: '#0181FF',
    },
    success: {
      main: '#00A393',
    },
    common: {
      gray: '#909090',
      lightNavy: '#8F9199',
      lightBlue: '#F9FCFF',
      greyLight: '#F3F3F3',
      blazeOrange: '#F56A000A',
      pendingOrange: '#FFB027',
    },
    general: {
      red: colors.lm_secondary_red,
      blue: '#0181FF',
      green: '#19A593',
      lightBlue: '#59A5F2',
      lightGreen: '#19a59380',
      extraLightBlue: '#59a5f233',
      extraLightGreen: '#19a59333',
      grey: colors.lm_grayscale_grey_50,
      grey40: colors.lm_grayscale_grey_40,
      grey60: colors.lm_grayscale_grey_60,
      grey70: colors.lm_grayscale_grey_70,
      grey100: colors.lm_grayscale_grey_100,
      lightGrey: '#cccccc',
    },
    sidebar: {
      active: '#0181FF',
      activeBackground: '#E5F2FF',
      color: 'rgba(77,79,98,.8)',
      divider: '#EEEEEE',
    },
    dividers: {
      primary: '#EEEEEE',
    },
    tooltip: {
      background: '#757575',
    },
    tables: {
      border: '#DDDDDD',
      borderRows: colors.lm_grayscale_grey_50,
      color: '#303032',
      header: '#F4F5F7',
    },
    statitstics: {
      available: '#00A393',
      reserved: '#0181FF',
      offline: '#585858',
      late: '#FA5252',
      availableBg: '#019183',
      reservedBg: '#0176E8',
      offlineBg: '#484848',
      lateBg: '#DE5151',
    },
    reservation_status: {
      noshow: '#585858',
      pending: '#FFB027',
      reserved: '#0181FF',
      cancelled: '#FA5252',
      rejected: '#FA5252',
      completed: '#909090',
      inProgress: '#11A71B',
    },
    subscription_status: {
      default: '#585858',
      pending: '#FFB027',
      inProgress: '#11A71B',
      cancelled: '#FA5252',
      completed: '#909090',
      rejected: '#FA5252',
      startexchange: '#F56A00',
      endexchange: '#F56A00',
      needsapproval: '#FFB027',
      deliveryinprogress: '#11A71B',
      available: 'FFB027',
      unpaid: '#FA5252',
    },
    statuses: {
      none: '#939393',
      paid: '#11A71B',
      open: '#0181FF',
      quote: '#00A393',
      closed: '#11A71B',
      failed: '#FA5252',
      noshow: '#FFB027',
      unpaid: '#FA5252',
      partial: '#F56A00',
      pending: '#FFB027',
      disputed: '#F56A00',
      overpaid: '#0181FF',
      refunded: '#0181FF',
      reserved: '#0181FF',
      rejected: '#FA5252',
      approved: '#11A71B',
      cancelled: '#FA5252',
      completed: '#11A71B',
      inProgress: '#FFB027',
      notStarted: '#909090',
      started: '#FFB027',
      pendingApproval: '#F56A00',
      preauthRefunded: '#0181FF',
      unPaidInProgress: '#0294AF',
      dl_passed: '#1E9E29',
      dl_failed: '#DF374B',
      dl_not_performed: '#777777',
    },
    priorities: {
      low: '#11A71B',
      medium: '#0294AF',
      high: '#F56A00',
      urgent: '#FA5252',
    },
    text: {
      primary: '#2C2C2E',
      secondary: '#777777',
      subtitle: '#4D4F5C',
      disabled: '#70727c',
    },
    background: {
      default: '#F4F5F7',
      input: colors.lm_grayscale_grey_10,
      paper: '#fff',
      container: '#F4F5F766',
    },
    form: {
      border: '#777777',
      textColor: '#2C2C2E',
      labelColor: '#707070',
      borderDark: '#E5E5E5',
      placeholder: '#979FAE',
      labelFilledColor: '#777777',
    },
    border: {
      color: 'rgba(0, 0, 0, 0.12)',
      width: '1px',
      radius: '4px',
      default: '1px solid rgba(0, 0, 0, 0.12)',
      warning: '1px solid #F56A0019',
    },
    divider: '#DBE0E7',
    status: {
      active: '#11A71B',
    },
    documents: {
      approved: '#11A71B',
      declined: '#FA5252',
      expired: '#F56A00',
      pending: '#FFB027',
      uploaded: '#0294AF',
      default: '#4D4F5C',
      defaultBg: '#7777770D',
      approvedBg: '#11A71B0D',
      declinedBg: '#FA52520D',
      expiredBg: '#F56A000D',
      pendingBg: '#FFB0270D',
      uploadedBg: '#0294AF0D',
    },
    widgets: {
      text: {
        primary: '#4D4F5C',
      },
    },
    itemList: {
      border: {
        low: '3px solid #11A71B',
        high: '3px solid #F56A00',
        medium: '3px solid #0294AF',
        urgent: '3px solid #FA5252',
        normal: '3px solid #0181FF',
      },
    },
    images: {
      checkbox: '#cfcece',
      modaltext: '#4D4F5C',
      uploadText: '#9E9E9E',
      uploadImage: '#f7f7f7',
      uploadBorderSolid: '1px solid #EEEEEE',
      uploadBorderDashed: '1px dashed #EEEEEE',
    },
    scheduler: {
      darkText: '#1D242D',
      fieldBorder: '#ced4da',
      grayLight: '#A3ADBA',
      grayLight400: '#626D7A',
    },
  },
  typography: {
    fontFamily: "'Helvetica Neue', 'Montserrat', 'Roboto', sans-serif",
    helveticaFont: 'Helvetica',
    appFontSize: '14px',
    button: {
      fontWeight: 600,
    },
  },
});
